import { render } from "./DatasourceFileUpload.vue?vue&type=template&id=5d446eee&ts=true"
import script from "./DatasourceFileUpload.vue?vue&type=script&lang=ts"
export * from "./DatasourceFileUpload.vue?vue&type=script&lang=ts"

import "./DatasourceFileUpload.vue?vue&type=style&index=0&id=5d446eee&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__